export default __webpack_public_path__ + "static/media/shop-mobile.cde45bea.png";